/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import '@fontsource/great-vibes';
import '@fontsource/montserrat';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module/dist/TagManager';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import App from './App';
import { AppWrapper } from './context/state';
import './index.css';
import reportWebVitals from './reportWebVitals';
import store from './store';

const tagManagerArgs = {
  gtmId: 'GTM-WCCFKV46'
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <Provider store={store}>
    <AppWrapper>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </AppWrapper>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
